import { styled } from "@mui/material";
import { HTMLAttributes } from "react";

const Status = styled("output")(() => ({
  position: "absolute",
  left: -9999,
  cursor: "default",
}));

type Props = HTMLAttributes<HTMLSpanElement>;

export function A11yStatus(props: Props) {
  return <Status tabIndex={-1} {...props} />;
}
